import CloseIcon from "@mui/icons-material/Close";

import Dialog from "@mui/material/Dialog";

import IconButton from "@mui/material/IconButton";

import { useTheme } from "@mui/material/styles";

import useMediaQuery from "@mui/material/useMediaQuery";

import { createUseStyles } from "react-jss";

import { Details, HskEntry } from "../helpers/types";

import CardDetails from "./CardDetails";



const CARD_SHELL = {

  border: "#404754",

  shadow: "0 1px 3px rgba(0, 0, 0, 0.24)"

};



const META_COLORS = { bg: "#E6E1FB", text: "#5A4FA5" };



const allFieldsDetailsOptions: Details = {

  front: { charSimp: true, charTrad: true, pinyin: true, meaning: true },

  back: { charSimp: false, charTrad: false, pinyin: false, meaning: false }

};



const useStyles = createUseStyles({

  backdrop: {

    backgroundColor: "rgba(15, 23, 42, 0.72)"

  },

  paper: {

    backgroundColor: "transparent",

    boxShadow: "none",

    overflow: "visible",

    margin: 16,

    width: "calc(100% - 32px)",

    maxWidth: 420

  },

  cardShell: {

    position: "relative",

    border: "1px solid",

    borderColor: CARD_SHELL.border,

    borderRadius: 12,

    boxShadow: CARD_SHELL.shadow,

    boxSizing: "border-box",

    width: "100%",

    minHeight: 140,

    backgroundColor: "transparent",

    overflow: "hidden"

  },

  cardShellMobile: {

    minHeight: "52vh"

  },

  cardInner: {

    display: "flex",

    flexDirection: "column",

    minHeight: "inherit",

    height: "100%",

    backgroundColor: "#2c3139",

    color: "#e2e8f0",

    borderRadius: 11

  },

  cardInnerMobile: {

    minHeight: "52vh",

    justifyContent: "center"

  },

  closeBtn: {

    position: "absolute",

    top: 8,

    right: 10,

    zIndex: 2,

    color: "#94a3b8",

    backgroundColor: "rgba(44, 49, 57, 0.92)",

    "&:hover": {

      backgroundColor: "rgba(44, 49, 57, 1)",

      color: "#e2e8f0"

    }

  },

  metaRow: {

    display: "flex",

    justifyContent: "center",

    gap: 6,

    flexWrap: "wrap",

    padding: "0 12px 12px"

  },

  metaPill: {

    display: "inline-flex",

    alignItems: "center",

    justifyContent: "center",

    borderRadius: 8,

    padding: "6px 12px",

    fontSize: 13,

    fontWeight: 500,

    lineHeight: 1.3,

    backgroundColor: META_COLORS.bg,

    color: META_COLORS.text

  }

});



const CardDetailPopover = ({

  card,

  open,

  onClose

}: {

  card: HskEntry | null;

  open: boolean;

  onClose: () => void;

}) => {

  const classes = useStyles();

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));



  if (!card) {

    return null;

  }



  const cardDetails = {

    level: card.level,

    charSimp: card.charSimp,

    charTrad: card.charTrad,

    freqRaw: card.freqRaw,

    freqPerc: card.freqPerc,

    pinyin: card.pinyin,

    meaning: card.meaning

  };

  const freqLabel =

    card.freqPerc > 0 ? `${card.freqPerc.toFixed(2)}% lit. coverage` : `${card.freqRaw.toLocaleString()} occurrences`;



  return (

    <Dialog

      open={open}

      onClose={onClose}

      slotProps={{

        backdrop: { className: classes.backdrop },

        paper: { className: classes.paper, elevation: 0 }

      }}

      aria-labelledby="card-detail-title">

      <div

        className={`${classes.cardShell} ${isMobile ? classes.cardShellMobile : ""}`}

        id="card-detail-title">

        <IconButton

          aria-label="Close card details"

          onClick={onClose}

          size="small"

          className={classes.closeBtn}>

          <CloseIcon fontSize="small" />

        </IconButton>

        <div className={`${classes.cardInner} ${isMobile ? classes.cardInnerMobile : ""}`}>

          <CardDetails

            cardDetails={cardDetails}

            currentSide="front"

            detailsOptions={allFieldsDetailsOptions}

            isMobile={isMobile}

            embedded

          />

          <div className={classes.metaRow}>
            <span className={classes.metaPill}>{card.order}</span>
            <span className={classes.metaPill}>HSK {card.level}</span>
            <span className={classes.metaPill}>{freqLabel}</span>
          </div>

        </div>

      </div>

    </Dialog>

  );

};



export default CardDetailPopover;


